import axios from '../api' // 倒入 api\

// 工作台计数
const getWCount = (params) => {
  return axios({
    url: '/api/workspace/count',
    method: 'GET',
    params,
  })
}

// 待处理列表--用车
const getWaitList = (data) => {
  return axios({
    url: '/api/workspace/wait/carorder/examine/list',
    method: 'POST',
    data,
  })
}

// 待处理列表--派车
const getWDispatchList = (data) => {
  return axios({
    url: '/api/workspace/wait/carorder/examine/dispatch/list',
    method: 'POST',
    data,
  })
}

// 待处理列表--还车
const getWReturnList = (data) => {
  return axios({
    url: '/api/workspace/wait/carorder/examine/return/list',
    method: 'POST',
    data,
  })
}

// 已处理列表--用车
const getWDoneList = (data) => {
  return axios({
    url: '/api/workspace/carorder/done/list',
    method: 'POST',
    data,
  })
}

// 已发起列表--用车
const getWCarorderList = (data) => {
  return axios({
    url: '/api/workspace/carorder/list',
    method: 'POST',
    data,
  })
}

// 待处理/已处理列表--车务
const getWCheckPage = (params) => {
  return axios({
    url: '/api/workspace/car-service/check/page',
    method: 'GET',
    params,
  })
}

// 已发起列表--车务
const getWServicePage = (data) => {
  return axios({
    url: '/api/workspace/service/page',
    method: 'POST',
    data,
  })
}

// 待处理列表--私车审批
const getWaitPrivateList = (data) => {
  return axios({
    url: '/api/workspace/carorder/examine/private/list',
    method: 'POST',
    data,
  })
}

// 待处理列表--私车核实
const getWReturnPrivateList = (data) => {
  return axios({
    url: '/api/workspace/carorder/confirm/private/list',
    method: 'POST',
    data,
  })
}

// 已处理列表--私车
const getWDonePrivateList = (data) => {
  return axios({
    url: '/api/workspace/carorder/done/private/list',
    method: 'POST',
    data,
  })
}

// 已发起列表--私车
const getWInitPrivateList = (data) => {
  return axios({
    url: '/api/workspace/carorder/private/list',
    method: 'POST',
    data,
  })
}

// 车务提醒列表
const getWServiceRemind = (params) => {
  return axios({
    url: '/api/workspace/service/remind',
    method: 'GET',
    params,
  })
}

// 查询车务提醒设置
const getWServiceSetting = (params) => {
  return axios({
    url: '/api/workspace/service/remind/setting',
    method: 'GET',
    params,
  })
}

// 车务提醒设置
const setWServiceSetting = (data) => {
  return axios({
    url: '/api/workspace/service/remind/setting',
    method: 'POST',
    data,
  })
}

export default {
  getWCount,
  getWaitList,
  getWDispatchList,
  getWReturnList,
  getWDoneList,
  getWCarorderList,
  getWCheckPage,
  getWServicePage,
  getWaitPrivateList,
  getWReturnPrivateList,
  getWDonePrivateList,
  getWInitPrivateList,
  getWServiceRemind,
  getWServiceSetting,
  setWServiceSetting,
}
